module.exports = __webpack_public_path__ + "static/img/12.f6bcb98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/12.png
// module id = l43V
// module chunks = 0